import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { storage } from '../logic/zustand'

const initialState = {
  company: '',
  email: '',
  name: '',
  phone: '',
  vatNumber: '',
}

interface State {
  company: string
  email: string
  name: string
  phone: string
  vatNumber: string

  set(payload: Partial<typeof initialState>): void
  clear(): void
}

const useContactDetails = create(
  persist<State>(
    set => ({
      ...initialState,

      clear: () => set(initialState),
      set,
    }),
    { name: 'contactDetails', storage },
  ),
)

export default useContactDetails
